import React from 'react';
import { itProjects } from '../data/projectsData';

const num = (i) => String(i + 1).padStart(2, '0');

const toParagraphs = (description) =>
  Array.isArray(description) ? description : [description];

export default function ITProjects() {
  return (
    <section id="it-projects" className="py-7" aria-labelledby="it-projects-heading">
      <h2
        id="it-projects-heading"
        className="mb-2 block font-extrabold uppercase tracking-[-0.01em] text-[32px] text-[#FBF0DC]/80"
      >
        IT Projects
      </h2>
      {itProjects.map((project, i) => (
        <article
          key={project.title}
          className="grid grid-cols-[auto_minmax(0,1fr)] items-baseline gap-x-5 gap-y-4 border-t-2 border-[#FBF0DC]/35 py-[18px] sm:grid-cols-[minmax(56px,110px)_minmax(0,1fr)] sm:gap-x-[clamp(24px,4vw,56px)]"
        >
          <p className="m-0 font-extrabold text-[15px]">{num(i)}</p>
          <div>
            <h3 className="m-0 mb-2.5 font-extrabold tracking-[-0.01em] text-2xl">{project.title}</h3>
            <div className="mb-3.5 max-w-[68ch] space-y-3 text-base leading-[26px] text-[#FBF0DC]/[0.78]">
              {toParagraphs(project.description).map((para, p) => (
                <p key={p} className="m-0">{para}</p>
              ))}
            </div>
            <div className="mb-3.5 flex flex-wrap gap-2">
              {project.tech.map((tag) => (
                <span key={tag} className="tag">{tag}</span>
              ))}
            </div>
            <div className="flex flex-wrap gap-5">
              {project.github && (
                <a className="proj-link" href={project.github} target="_blank" rel="noopener noreferrer">
                  GitHub →
                </a>
              )}
              {project.linkedin && (
                <a className="proj-link" href={project.linkedin} target="_blank" rel="noopener noreferrer">
                  LinkedIn →
                </a>
              )}
              {project.demo && (
                <a className="proj-link" href={project.demo} target="_blank" rel="noopener noreferrer">
                  Demo →
                </a>
              )}
            </div>
          </div>
        </article>
      ))}
    </section>
  );
}
